import { render, staticRenderFns } from "./Banners.vue?vue&type=template&id=519ac846&scoped=true"
import script from "./Banners.vue?vue&type=script&lang=ts"
export * from "./Banners.vue?vue&type=script&lang=ts"
import style0 from "./Banners.vue?vue&type=style&index=0&id=519ac846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519ac846",
  null
  
)

export default component.exports